<template>
  <div class="add-users-wrap">
    <div class="form-wrap">
      <h1>{{$t('adminAdd.addNewUser')}}</h1>
      <div class="input-wrap">
        <label for="name">{{$t('register.name')}}:</label>
        <input type="text" id="name" v-model.trim="name" :class="nameErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="nameErrors.length !== 0">
          <label v-for="error in nameErrors" :key="error" class="error" for="name">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="lastName">{{$t('register.lastName')}}:</label>
        <input type="text" id="lastName" v-model.trim="lastName" :class="lastNameErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="lastNameErrors.length !== 0">
          <label v-for="error in lastNameErrors" :key="error" class="error" for="lastName">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="email">{{$t('register.email')}}:</label>
        <input type="text" id="email" v-model.trim="email" :class="emailErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="emailErrors.length !== 0">
          <label v-for="error in emailErrors" :key="error" class="error" for="email">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="password">{{$t('register.password')}}:</label>
        <input type="password" id="password" v-model="password" :class="passwordErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="passwordErrors.length !== 0">
          <label v-for="error in passwordErrors" :key="error" class="error" for="password">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="confirmPassword">{{$t('register.confirmPassword')}}:</label>
        <input type="password" id="confirmPassword" v-model="confirmPassword"  :class="confirmPasswordErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="confirmPasswordErrors.length !== 0">
          <label v-for="error in confirmPasswordErrors" :key="error" class="error" for="confirmPassword">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="birthDate">{{$t('register.birthDate')}}:</label>
        <input type="date" placeholder="Choose a Date" id="birthDate" v-model="birthDate">
      </div>
      <div class="input-wrap">
        <p>{{$t('register.gender')}}:</p>
        <select name="gender" id="gender" v-model="gender">
          <option value="m">{{$t('register.genderType.m')}}</option>
          <option value="f">{{$t('register.genderType.f')}}</option>
          <option value="u">{{$t('register.genderType.o')}}</option>
        </select> 
      </div>
      <div class="input-wrap">
        <label for="country">{{$t('register.country')}}:</label>
        <select name="countries" id="country" v-model="country">
          <option v-for="country in countries" 
            :value="country.id"
            :key="country.id"
          >{{country.name}}</option>
        </select>
      </div>
      <div class="input-wrap">
        <label for="city">{{$t('register.city')}}:</label>
        <input type="text" id="city" v-model.trim="city" :class="cityErrors.length !== 0? 'hasError' : ''">
        <div class="errors" v-if="cityErrors.length !== 0">
          <label v-for="error in cityErrors" :key="error" class="error" for="city">{{error}}</label>
        </div>
      </div>
      <div class="input-wrap">
        <label for="roles">{{$t('adminAdd.chooseRole')}}:</label>
        <select name="roles" id="roles" v-model="roleId">
          <option v-for="role in roles"
            :key="role.rol_id"
            :value="role.rol_id"
          >{{ role.rol_name }}</option>
        </select>
      </div>
      <div class="button-wrap">
        <button class="add-button" @click="addNewUser">{{$t('adminAdd.addUser')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import AdminMixin from './adminMixin';
export default {
  mixins: [
    AdminMixin
  ],
  data () {
    return {
      countries: [],
      name: '',
      nameErrors: [],
      lastName: '',
      lastNameErrors: [],
      email: '',
      emailErrors: [],
      password: '',
      passwordErrors: [],
      confirmPassword: '',
      confirmPasswordErrors: [],
      birthDate: '',
      gender: '',
      country: '',
      city: '',
      cityErrors: [],
      roles: [],
      roleId: null
    }
  },
  mounted () {
    this.init();
    window.addEventListener('keyup', this.bindSubmitOnEnter);
  },
  destroyed () {
    window.removeEventListener('keyup', this.bindSubmitOnEnter);
  },
  methods: {
    async init () {
      this.startLoading();
        await this.getCountries();
        await this.getUserRoles();
      this.stopLoading();
    },
    async getCountries () {
      let apiObj = {
        api: api.getCountries,
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);
      this.countries = data.countries;
    },
    async getUserRoles () {
      let apiObj = {
        api: api.getRoles,
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);
      this.roles = data.res;
    },
    async addNewUser () {
      if (this.hasErrors()) {
        return;
      }
      const apiObj = {
        api: api.addNewUser,
        params: {
          firstname: this.name,
          lastname: this.lastName,
          email: this.email,
          password: this.password,
          rol_id: this.roleId,
        }
      }

      if (this.country) apiObj.params.country = this.country;
      if (this.gender) apiObj.params.gender = this.gender;
      if (this.city) apiObj.params.city = this.city;
      if (this.birthdate) apiObj.params.birthdate = this.birthdate;

      this.startLoading();
        const data = await this.apiCall(apiObj);
        if (data) {
          this.showSuccessMessage(this.$t('adminAdd.newUserAdded'))
        }
      this.stopLoading();
    },
    hasErrors () {
      this.clearErrors();
      this.checkForNameErrors();
      this.checkForLastnameErrors();
      this.checkForPasswordErrors();
      this.checkForConfirmPasswordErrors();
      this.checkForEmailErrors();
      // this.checkForCityErrors();
      this.checkForRole();

      if (this.nameErrors.length !== 0 || 
          this.lastNameErrors.length !== 0 || 
          this.passwordErrors.length !== 0 || 
          this.confirmPasswordErrors.length !== 0 || 
          this.emailErrors.length !== 0 ||
          !this.roleId
      ) {
        return true
      } else {
        return false
      }
    },
    clearErrors () {
      this.nameErrors = [];
      this.lastNameErrors = [];
      this.passwordErrors = [];
      this.confirmPasswordErrors = [];
      this.emailErrors = [];
    },
    checkForNameErrors () {
      if (this.name === '') {
        this.nameErrors.push(this.$t('register.nameError'))
      }

      if (this.name.length > 250) {
        this.nameErrors.push(this.$t('register.nameLengthError'))
      }
    },
    checkForLastnameErrors () {
      if (this.lastName === '') {
        this.lastNameErrors.push(this.$t('register.lastNameError'))
      }

      if (this.lastName.length > 250) {
        this.lastNameErrors.push(this.$t('register.lastNameLengthError'))
      }
    },
    checkForPasswordErrors () {
      if (this.password === '') {
        this.passwordErrors.push(this.$t('register.passwordEmptyError'))
      }

      if (this.password.length < 8) {
        this.passwordErrors.push(this.$t('register.passwordError'))
      }
    },
    checkForConfirmPasswordErrors () {
      if (this.confirmPassword === '') {
        this.confirmPasswordErrors.push(this.$t('register.confirmPasswordEmptyError'))
      }

      if (this.password !== this.confirmPassword) {
        this.confirmPasswordErrors.push(this.$t('register.confirmPasswordError'))
      }
    },
    checkForEmailErrors () {
      const emailCheck = /^(\w+.?)+@(\w+.?)+.\w+$/.test(this.email)
      if (!emailCheck && this.email !== '') {
        this.emailErrors.push(this.$t('register.emailError'))
      }

      if (this.email === '') {
        this.emailErrors.push(this.$t('register.emailEmptyError'))
      }
    },
    checkForCityErrors () {
      if (this.city === '') {
        this.cityErrors.push(this.$t('register.cityError'))
      }

      if (this.city.length > 250) {
        this.cityErrors.push(this.$t('register.cityLengthError'))
      }
    },
    checkForRole () {
      if (!this.roleId) {
        this.handleError(new Error(this.$t('register.roleError')))
      }
    },
    bindSubmitOnEnter(e){
      if (e.keyCode === 13) { 
          this.addNewUser();
      }
    }
  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }
  .add-users-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #E5E5E5;
  }
  .form-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 35%;
    padding: 2%;
    box-shadow: 0px 0px 36px -11px rgba(0,0,0,0.75);
    border-radius: 20px;
  }
  .input-wrap {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
  .input-wrap p {
    margin: 0;
  }
  .add-users-wrap div {
    margin: 1% 0;
  }
  .radio-wrap {
    width: 90%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10%;
  }
  .each-radio {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-basis: 20%;
  }
  .each-radio label, input[type=radio] {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-align: center;
  }
  .each-radio label {
    height: 45px;
  }
  input[type=radio] {
    height: 20px;
  }
  .input-wrap input.hasError {
    border: 1.5px solid red;
  }
  .error {
    color: red;
    font-size: 0.8em
  }
  .errors {
    display: flex;
    flex-direction: column;
    margin: 0;
  }
  p.user-role {
    text-align: start;
    width: 70%;
    margin: 0;
  }
  .add-button {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    border: none;
    padding: 10% 15%;
    box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
    border-radius: 100px;
    font-size: 17px;
    font-weight: 600;
    background: var(--button-color-blue);
    color:white;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .add-button:active, .add-button:focus {
    border: none;
    outline: none;
  }
</style>